import { ActionTypes } from 'store/actions/loader';

const defaultSessionState = {
    loaderVisibilityStatus: false
};

function loader (state = defaultSessionState, action) {
    switch (action.type) {
        case ActionTypes.SET_LOADER_VISIBILITY:
            return {
                ...action.session,
                loaderVisibilityStatus: action.payload
            };

        default:
            return state;
    }
}

export default loader;



// WEBPACK FOOTER //
// ./src/js/store/reducers/loader.js